import { createContext } from 'react'

interface RowContextType {
  setActivatorNodeRef?: (element: HTMLElement | null) => void,
  listeners?: Record<string, unknown>,
  isFixed?: boolean
}

export const RowContext = createContext<RowContextType>({})
